import { Alert, Button, Modal } from "@arco-design/web-react";
import { MoveRight } from "lucide-react";
import { useState } from "react";
import type { ItineraryCopyTarget } from "../types";
import { ItineraryCopyTargetSelect } from "./ItineraryCopyTargetSelect";

type Props = {
  items: ItineraryCopyTarget[];
  hasTargets: boolean;
  selectedDemandId: string;
  loading: boolean;
  moving: boolean;
  errorMessage: string;
  onSearch: (keyword: string) => void;
  onSelect: (demandId: string) => void;
  onConfirm: (replaceExisting?: boolean) => Promise<void>;
  onCancel: () => void;
  onRetry: () => void;
};

/** 同一定制版本内移动原行程，替换既有关联前要求二次确认。 */
export function ItineraryMoveBar(props: Props) {
  const [confirmation, setConfirmation] = useState<ItineraryCopyTarget>();
  const selected = props.items.find((item) => item.demandId === props.selectedDemandId);
  const unavailable = props.loading || props.moving || !selected || Boolean(props.errorMessage);
  const submit = (replaceExisting = false) => {
    setConfirmation(undefined);
    if (!unavailable) void props.onConfirm(replaceExisting);
  };
  return <>
    <div className="itinerary-copy-bar itinerary-move-bar" aria-label="移动行程">
      <ItineraryCopyTargetSelect hasSearched items={props.items}
        selectedDemandId={props.selectedDemandId} loading={props.loading}
        disabled={props.moving} placeholder="搜索选择当前定制的其他版本"
        emptyMessage={props.errorMessage || (props.hasTargets
          ? "没有匹配的版本，请更换或清空关键词" : "当前定制暂无其他可移动版本")}
        onSearch={props.onSearch} onSelect={props.onSelect} />
      <Button type="primary" className="itinerary-copy-button" icon={<MoveRight size={15} />}
        loading={props.moving} disabled={unavailable}
        onClick={() => selected?.hasItinerary ? setConfirmation(selected) : submit()}>
        移动行程
      </Button>
      <Button disabled={props.moving} onClick={props.onCancel}>取消</Button>
      {props.errorMessage ? <Alert type="error" showIcon content={props.errorMessage}
        action={<Button size="small" disabled={props.moving} onClick={props.onRetry}>重试</Button>} /> : null}
    </div>
    <Modal visible={Boolean(confirmation)} title="确认替换定制版本关联行程"
      okText="确认移动" cancelText="取消" maskStyle={{ zIndex: 1299 }} wrapStyle={{ zIndex: 1300 }}
      onCancel={() => setConfirmation(undefined)} onOk={() => {
        if (confirmation?.demandId !== props.selectedDemandId) { setConfirmation(undefined); return; }
        submit(true);
      }}>
      <p>{confirmation?.projectCode} {confirmation?.versionNumber} 已关联行程。</p>
      <p>确认后，当前行程及其核价、报价、确认件将一并归属该版本。该版本原有关联的行程及其单据保留，但不再作为当前行程。</p>
    </Modal>
  </>;
}
